import { setSingleVariantProductDataAction as setSingleVariantProductDataOperation } from '../slice';

export default setSingleVariantProductDataOperation;
